import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    Router,
    RouterStateSnapshot,
    UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';

import { AuthService } from '../services';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard {
    constructor(
        private readonly _auth: AuthService,
        private readonly _router: Router
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        if (this._auth.isSignedIn) {
            return true;
        } else {
            this._router.navigate(['/']);
            return false;
        }
    }
}
